import authenticationService from '@src/api/services/AuthenticationService.ts';

export type OrganizationsListViewLoaderData = Awaited<
  ReturnType<typeof organizationsListViewLoader>
>;

export const organizationsListViewLoader = async () => {
  const currentUser = await authenticationService.getCurrentUser();
  return {
    currentUser,
  };
};
